import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AppHeader } from "@/components/brand/AppHeader";
import { AdTemplateEditor } from "@/components/adtemplate/AdTemplateEditor";

export default function SellerListingEditor() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <AdTemplateEditor key={id} horseId={id}
      onLoadError={() => { toast.error("Listing not found"); navigate("/dashboard"); }}
      renderHeader={({ bar, flush, horse, isAdTemplate }) => (
        <AppHeader title={horse.horse_info?.horse_name || "Untitled horse"} eyebrow={isAdTemplate ? "Horse Ad Template" : "Listing"} home="/dashboard" width="max-w-6xl"
          onBack={async () => { await flush(); navigate("/dashboard"); }} backTestId="back-to-dashboard" below={bar} />
      )} />
  );
}
